export default {
  data() {
    return {
      menuOpen: false,
      observer: null,
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.initializeAnimations();
  },
  methods: {
    goToContact() {
      this.$router.push('/contact');
    },
    initializeAnimations() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");

              const delay =
                Array.from(entry.target.parentNode.children).indexOf(entry.target) * 100;
              setTimeout(() => {
                entry.target.style.transitionDelay = `${delay}ms`;
              }, 0);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px",
        }
      );

      this.$nextTick(() => {
        const animatedElements = document.querySelectorAll(".animate-on-scroll");
        animatedElements.forEach((el) => {
          this.observer.observe(el);
        });
      });
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};